<template>
  <section>
    <img
      src="../../../assets/images/combook_binding/about.png"
      alt=""
      width="411"
      class="card-img"
    />
    <p class="card-title">連絡帳製本</p>
    <p>
      日々書き留めた連絡帳の記録を、たったひとつの特別な本として製本します。<br />
      お子さまのかけがえのない瞬間が詰まった一冊は、いつでも手にとって読み返すことができる大切な宝物となります。<br />
      愛おしい想い出を形に残しませんか？
    </p>
    <a
      href=""
      class="bold"
      @click.prevent="$emit('show-product-detail-full-screen-dialog')"
      >商品詳細を見る</a
    >
  </section>
</template>

<script>
export default {
  name: "CombookBindingOverview"
};
</script>

<style scoped>
a.bold {
  font-weight: bold;
}
.card-img {
  margin-bottom: 16px;
}
.card-title {
  font-weight: bold;
  margin-bottom: 8px;
}
</style>
